import { useState, useEffect } from 'react';
import Text from '../Base/Text/Text';
import Checkbox from '../Base/Checkbox/Checkbox';
import GlucoseChart from '../Shared/Charts/GlucoseChart';
import BloodPressureChart from '../Shared/Charts/BloodPressureChart';
import WeightChart from '../Shared/Charts/WeightChart';
import SideFilter from '../Filter/SideFilter';
import TextField from '../Base/TextField/TextField';
import SideFilterLabel from '../Filter/SideFilterLabel';
// @ts-ignore
import styles from './HealthData.module.scss';

interface HealthData {
	patientId: string;
}

interface HealthDataSource {
	appleHealth: boolean;
	googleFit: boolean;
	questionnaire: boolean;
}

export default function HealthData(props: HealthData) {
	const { patientId } = props;

	return (
		<>
			<div className={styles.wrapper}>
				<div className={styles.filterWrapper}>
					<SideFilter className={styles.filter}></SideFilter>
				</div>
				<div className={'flex-grow-1 position-relative'}>
					<div className={styles.chartsWrapper}></div>
				</div>
			</div>
		</>
	);
}
